// removed by extract-text-webpack-plugin
module.exports = {"card":"card__3qhPK","custom-p":"custom-p__3NFbP","mw135":"mw135__1neeW","selected":"selected__iHrph","mw320":"mw320__2TdeB","mw100":"mw100__By0xB","amount-input-container":"amount-input-container__uvv4a","amount-input":"amount-input__2TMz7","roadmap-card":"roadmap-card__225iF","roadmap-table":"roadmap-table__WqCeS","btn-container":"btn-container__2Vgta","prev":"prev__84qb2","next-main":"next-main__aXngu","year-container":"year-container__2g8ML"};


//////////////////
// WEBPACK FOOTER
// ./styles/f2s/f2sV5Style.scss
// module id = 249
// module chunks = 68